import { TooltipStatus, useTooltipTitle } from '../status/TooltipStatus'
import { useIntl, FormattedMessage } from 'react-intl'
import * as R from 'ramda'
import React from 'react'

const CancelScheduleNotificationStatus = ({ notification }) => {
  const { formatMessage } = useIntl()
  const createTitle = useTooltipTitle()
  const performDate = R.prop('scheduleCancelDate', notification)
  const person = R.prop('scheduleCanceledBy', notification)
  const titleObj = createTitle(person, performDate)

  const title = formatMessage(
    { id: 'notificationTimeline.card.cancelBy.title' },
    titleObj,
  )
  return (
    <TooltipStatus
      title={title}
      status={
        <FormattedMessage id="notificationTimeline.card.status.canceled" />
      }
    />
  )
}

export default React.memo(CancelScheduleNotificationStatus)
